'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '../ui/paragraph';
import { Heading } from '../ui/heading';
import { Button } from '../ui/button';

import type { TDynamicData } from '../../types/dynamic-data';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@eliadmin/core/src/components/ui/accordion';

import { IoPlayCircleOutline } from 'react-icons/io5';
import { LuMinus, LuPlus } from 'react-icons/lu';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function About({
  questions,
  image,
  subtitle,
  title,
  url,
}: {
  questions: TDynamicData[];
  image: string;
  subtitle: string;
  title: string;
  url: string;
}) {
  const { t } = useTranslations();

  return (
    <section
      id="o-nas"
      className={cn('custom-section', 'pb-8 pt-16 sm:pb-16 sm:pt-24 lg:pb-[72px] lg:pt-36')}
    >
      <div
        className={cn(
          'custom-container',
          'flex flex-col items-start justify-start gap-8 md:flex-row md:items-center md:justify-between',
        )}
      >
        <div className="flex w-full flex-col items-start justify-start gap-8 md:max-w-[620px]">
          <Heading subtitle={subtitle} title={title} />
          <Accordion type="single" collapsible className="flex w-full flex-col gap-2">
            {questions.map(item => (
              <AccordionItem value={item.name} key={item.name} className="w-full border-none">
                <AccordionTrigger
                  hideIcon
                  className={cn(
                    'ea-about__accordion-trigger',
                    'flex items-center justify-between py-[12.5px] text-left text-lg font-medium tracking-tighter sm:py-4 sm:text-xl',
                  )}
                >
                  {item.name}
                  <div>
                    <LuPlus size={24} className="text-primary" />
                  </div>
                  <span>
                    <LuMinus size={24} className="text-primary" />
                  </span>
                </AccordionTrigger>
                <AccordionContent className="mt-0 pt-4">
                  <Paragraph innerHtml={item.fields[0]?.value} className="w-full" />
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        <div className="relative aspect-square w-full max-w-[692px] overflow-hidden rounded-[24px]">
          {/* <Button
            asChild
            variant={'white'}
            className="absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap"
          >
            <Link prefetch={false} href={url} target="_blank">
              <IoPlayCircleOutline size={24} /> {t('text2335')}
            </Link>
          </Button> */}
          <Image
            src={image}
            alt={title}
            width={0}
            height={0}
            className="absolute inset-0 z-0 h-full w-full object-cover object-center"
            sizes="100vw"
          />
        </div>
      </div>
    </section>
  );
}
